Customer.Reports ||= {}

class Customer.Reports.ChartFactory

  charts: ->
    return {
      'table': Customer.Reports.TableReport
      'pie': Customer.Reports.PieReport
    }

  constructor: (@json, @container) ->

  create: ->
    return new (@charts()[@json.chart_type])(@json, @container)